
import React, { useState, useContext } from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, ListItemIcon, Grid,useMediaQuery} from "@material-ui/core"
import MenuIcon from '@material-ui/icons/Menu';
import { useHistory, useLocation } from "react-router-dom";
import './SideMenu.scss'
import { SessionService } from "../../services/SessionService";
import { ReactComponent as MonthlySvg } from '../../assets/sidemenu/monthly.svg'
import { ReactComponent as ClaimsSvg } from '../../assets/sidemenu/claims.svg'
import { ReactComponent as AnnualSvg } from '../../assets/sidemenu/annual.svg'
import { ReactComponent as FaqSvg } from '../../assets/sidemenu/faq.svg'
import { ReactComponent as LoginSvg } from '../../assets/sidemenu/login.svg'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { ReactComponent as PolicyManagementSvg } from '../../assets/sidemenu/policy_management.svg'
import EqualizerIcon from '@material-ui/icons/Equalizer';
import HomeIcon from '@material-ui/icons/Home';
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService";
import FlexView from "react-flexview/lib";
import { SessionContextStore } from "../../context/SessionContext/SessionContext";
import { SkywatchThemeContext } from "../../theme/Theme";
import { reportGTM } from "../Core/Utilities/GTagManger";
import { ReactComponent as SkywatchLogo } from '../../assets/skywatch-logo.svg';
import {SupportPhoneCall} from './AppBarItems/SupportPhoneCall'

var classNames = require('classnames');

// const MONTHLY_ROUTE = {text: "Monthly Insurance", path: "/insurance/monthly", showIfLoggedOut: FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE), showIfLoggedIn: FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE), icon: <MonthlySvg className="medium-icon" />, active: p => p.endsWith('monthly') };
// const ANNUAL_ROUTE = {text: "Annual Insurance", path: "/insurance/annual", showIfLoggedOut: FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE), showIfLoggedIn: FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE), icon: <AnnualSvg className="medium-icon"/>, active: p => p.endsWith('annual')};
const ROUTES = [
    // {text: "My Discounts", path: "/discounts/my-discounts", showIfLoggedOut: true, showIfLoggedIn: true, icon: <PriceTag className="medium-icon"/>, active: p => p.startsWith('/my-discounts')},
    {text: "Start a Quote", path: "/insurance", showIfLoggedOut: true, showIfLoggedIn: true, icon: <AnnualSvg className="medium-icon" />, active: p => p.startsWith('/insurance')},
    {text: "My Quotes", path: "/quotes", showIfLoggedOut: false, showIfLoggedIn: true, icon: <AnnualSvg className="medium-icon" />, active: p => p.startsWith('/quotes')},
    // {text: "Get a Quote", path: "/welcome", showIfLoggedOut: true, showIfLoggedIn: false, icon: <ClaimsSvg className="medium-icon" />, active: p => p.startsWith('/insurance')},
    // {text: "Account", path: "/account", showIfLoggedOut: false, showIfLoggedIn: true, icon: <LoginSvg className="medium-icon"/>, active: p => p.startsWith('/account')},
    FirebaseService.getBoolean(FirebaseConfigKey.INSURED_LOGIN_AVAILABLE) && {text: "Login", path: "/login", showIfLoggedOut: true, showIfLoggedIn: false, icon: <LoginSvg className="medium-icon"/>, active: p => p.endsWith('/login') || p.endsWith('logout')},
    {text: "Broker Login", path: "/broker-login", showIfLoggedOut: true, showIfLoggedIn: false, icon: <LoginSvg className="medium-icon"/>, active: p => p.endsWith('broker-login') || p.endsWith('logout')},
    {text: "Policy Management", path: "/policy-management", showIfLoggedOut: false, showIfLoggedIn: true, icon: <PolicyManagementSvg className="medium-icon"/>, active: p => p.startsWith('/policy-management')},
    {text: "Account", path: "/account", showIfLoggedOut: false, showIfLoggedIn: true, icon: <PolicyManagementSvg className="medium-icon"/>, active: p => p.startsWith('/account')},
    // {text: "Logout", path: "/logout", showIfLoggedOut: false, showIfLoggedIn: true, icon: <ExitToAppIcon className="medium-icon"/>, active: p => p.endsWith('logout')},
    // {text: "File a Claim", path: '/claim', showIfLoggedOut: true, showIfLoggedIn: true, icon: <ClaimsSvg className="medium-icon"/>, active: p => false},
    FirebaseService.getValue(FirebaseConfigKey.FAQ_URL) && {text: "FAQ", link: true, path: "https://skywatchaiowners.zendesk.com/hc/en-us", showIfLoggedOut: true, showIfLoggedIn: true, icon: <FaqSvg className="medium-icon"/>, active: p => false},
]

const BROKER_ROUTES = [
    {text: "Broker Portal", path: "/admin", showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: false, icon: <HomeIcon className="tealblue medium-icon"/>, active: p => p.endsWith('/portal')},
    {text: "Start a Quote", path: "/insurance", showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: true, icon: <AnnualSvg className="medium-icon" />, active: p => p.startsWith('/insurance')},
    {text: "User's Quotes", path: "/quotes", showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: true, icon: <AnnualSvg className="tealblue medium-icon"/>, active: p => p.endsWith('/portal')},
    {text: "User's Policies", path: "/policy-management", showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: true, icon: <PolicyManagementSvg className="medium-icon"/>, active: p => p.startsWith('/policy-management')},
    {text: "Recent Submissions", path: "/broker/accounts/recent", params: {tab: "recent"}, showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: false, icon: <MonthlySvg className="medium-icon"/>, active: p => p.endsWith('/accounts/recent')},
    {text: "Manage Accounts", path: "/broker/accounts/active", params: {tab: "active"}, showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: false, icon: <LoginSvg className="medium-icon"/>, active: p => p.endsWith('/accounts/active')},
    {text: "Skywatch Dashboard", link: true, path: "http://partnerd.eastus.cloudapp.azure.com/pages/dashboard", showIfLoggedOut: false, showIfLoggedIn: true, isImpersonationLink: false, icon: <EqualizerIcon className="tealblue medium-icon "/>, active: () => false},
    // {text: "Logout", path: "/logout", showIfLoggedOut: false, showIfLoggedIn: true, icon: <ExitToAppIcon className="medium-icon"/>, active: p => p.endsWith('logout')},
    // FirebaseService.getValue(FirebaseConfigKey.FAQ_URL) && {text: "FAQ", link: true, path: FirebaseService.getValue(FirebaseConfigKey.FAQ_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <FaqSvg className="medium-icon"/>, active: p => false},
]

const END_MENU_ROUTES = [
    // FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL) && {text: "Report a Bug", link: true, path: FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <BugSvg className="medium-icon"/>, active: p => false},
]

const useStyles = makeStyles({
    list: {
      width: 300,
    },
});


const SideMenu = (props) => {
    const [toggle, setToggle] = useState(false)
    const [activeInsuranceType, setActiveInsuranceType] = useState(undefined);
    const history = useHistory()
    const classes = useStyles()
    const location = useLocation();
    const { impersonationDetails, ...sessionContext } = useContext(SessionContextStore);
    const theme = useContext(SkywatchThemeContext);
    const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'));

    const turnToggle = () => {
        setToggle(true)
        reportGTM(location, 'Hamburger')
    }

    const isInFlow = location.pathname.startsWith('/insurance');
    
    const redirect = (item) => {
        if(item.link)
            window.open(item.path, '_blank')
        else 
            history.push(item.path, item.params ? item.params : {})
        setToggle(false)
        reportGTM(location, `Hamburger-${item.text.replaceAll(" ", "_")}`)
    }

    React.useEffect(() => {
        if (sessionContext.activeInsurance && sessionContext.activeInsurance.insuranceId){
            setActiveInsuranceType(sessionContext.activeInsurance.insuranceType)
        }
        else{
            setActiveInsuranceType(undefined);
        }
    }, [sessionContext.activeInsurance])

    const isLoginPage =  location.pathname == '/welcome' || location.pathname == '/login' || location.pathname == '/brokerLogin' || location.pathname == '/forgot-password' || location.pathname == '/register' || location.pathname == '/logout'
    const isProposalForm = location.pathname.includes('/proposal');

    let routes = SessionService.isLoggedIn() && SessionService.isBroker() ? BROKER_ROUTES : ROUTES
    
    if(location.pathname.startsWith('/odometer')) {
        return <div />
    }

    if (activeInsuranceType != undefined || location.pathname == '/brokerLogin' ){
        routes = routes.filter(q => q.text != "Start a Quote");
    }

    return (
        <React.Fragment>
            <AppBar color={'secondary'} position={'absolute'} 
                    elevation={0} 
                    className={"skywatch-appbar-login"}>
                <Toolbar>
                    <FlexView className="space-between full-width">
                        <Grid container alignItems="center" justifyContent="flex-start">
                            {!location.pathname.startsWith('/proposal') && 
                            <IconButton onClick={turnToggle} aria-label="menu">
                                <MenuIcon fontSize="large" className={classNames({"hamburger": !isLoginPage}, {"hamburger-login": isLoginPage}, {"hamburger-flow": isInFlow})} />
                            </IconButton> }
                            {/* {!isLoginPage && <img onClick={gotoHome} className="skywatch-logo" />} */}
                            <SkywatchLogo className="skywatch-logo" />
                            {isMobileByWidth&&<SupportPhoneCall />}
                            {/* <img className="margin-left-basic global-logo" src={GlobalLogo}/> */}
                        </Grid>
                    </FlexView>
                    {/* {isLoginPage && <InsurerLogo />} */}
                </Toolbar>
            </AppBar>
            <Drawer open={toggle} onClose={() => { setToggle(false) }}>
                <div>
                    <List className={classes.list}>
                        {routes.filter(route => {
                            if(route.isImpersonationLink){
                                if(impersonationDetails){
                                    return true;
                                }
                                return false;
                            }
                            return true
                        }).filter(route => SessionService.isLoggedIn() ? route.showIfLoggedIn : route.showIfLoggedOut).map((item, index) => 
                            <ListItem className="sidemenu-listitem" button onClick={() => redirect(item)} key={index}>
                                <ListItemIcon className={classNames({'sidemenu-icon-active': item.active(location.pathname)})}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primaryTypographyProps={{className: classNames('sidemenu-item', 'lightteal', {'sidemenu-active': item.active(location.pathname)})}} primary={item.text} />
                            </ListItem>
                        )}
                            {sessionContext.isLoggedIn && <ListItem className="sidemenu-listitem" button onClick={() => {
                                    setToggle(false)
                                    sessionContext.logout()
                                }}>
                                <ListItemIcon>
                                    <ExitToAppIcon className="medium-icon"/>
                                </ListItemIcon>
                                <ListItemText primaryTypographyProps={{className: classNames('sidemenu-item', 'lightteal')}} primary={"Logout"} />
                            </ListItem>}
                    </List>
                </div>
                <List className={classes.list}>
                        {END_MENU_ROUTES.filter(route => SessionService.isLoggedIn() ? route.showIfLoggedIn : route.showIfLoggedOut).map((item, index) => 
                            <ListItem className="sidemenu-listitem" button onClick={() => redirect(item)} key={index}>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primaryTypographyProps={{className: classNames('sidemenu-item', 'lightteal', {'sidemenu-active': item.active(location.pathname)})}} primary={item.text} />
                            </ListItem>
                        )}
                    </List>
            </Drawer>
        </React.Fragment>
    )
}

export default SideMenu